// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__rL5Lh","text":"SelectPayment_text__MuCwh","title":"SelectPayment_title__25NSH","btn":"SelectPayment_btn__28H-e"};